import React from 'react';
import { Typography, Box } from '@mui/material';
import { DropzoneArea } from "mui-file-dropzone";

function VideoUpload({ onFileSelect, selectedFiles }) {
    const handleFileChange = (files) => {
        if (files.length === 0) {
            onFileSelect(null);
            return;
        }
        if (files[0] === selectedFiles[0]) return;
        const file = files[0];
        onFileSelect(file);
    };

    return (
        <Box className={"center-box"} sx={{ maxWidth: '1200px' }}>
            <Typography variant="h6">Select Video File</Typography>
            <DropzoneArea 
                acceptedFiles={["video/*"]} 
                maxFileSize={100*1024*1024*1024} 
                filesLimit={1} 
                onChange={handleFileChange}
                initialFiles={selectedFiles} 
            />
            {selectedFiles.length > 0 && (
                <Typography variant="body1">Selected File: {selectedFiles[0].name}</Typography>
            )}
        </Box>
    );
}

export default VideoUpload;